import { MutationTree } from "vuex";
import { RootState, UploadedFile } from "./types";
import { updateField } from "vuex-map-fields";
export const mutations: MutationTree<RootState> = {
    updateField,
    addFile: (state: RootState, currentFile: UploadedFile) => {
        state.observationer.files.push(currentFile);
    },
    removeFile: (state: RootState, id: string) => {
        state.observationer.files = state.observationer.files.filter(
            (file: UploadedFile) => file.id !== id,
        );
    },
};
